import {
  Linking,
  ImageBackground,
  SafeAreaView,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Colors from "../../Theme/Colors";
import typo from "../../Theme/Typo";
import { Feather } from "@expo/vector-icons";
import { format } from "date-fns";

import Queries from "../../api/queries";
import QueryToken from "../../api/queries/queryToken";
import { fr } from "date-fns/locale";

import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import Button from "../Button";
import ModalQLerr from "../../utils/ModalQLerr";

import AlertCustom from "../utils/alert";

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

const InfoPerso = () => {
  const { t, i18n } = useTranslation();

  const [QLerror, setQLerror] = useState("");

  const queries = new Queries();
  const queriesToken = new QueryToken();

  const [invoices, setInvoices] = useState([]);
  const [prestaInfo, setPrestaInfo] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState<boolean>();

  const getPrestaInfos = async () => {
    try {
      const responseGraphql = await queries.getPrestaInfo();

      let errors = responseGraphql?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const prestaData = responseGraphql.data.getPrestaInfo;
        setPrestaInfo(prestaData);
        const graphqlRoles = await queriesToken.getPrestaRoles(
          prestaData.email
        );
        let errors = graphqlRoles?.errors;

        if (errors && errors.length > 0) {
          const errorMessage: string = errors[0].message;

          setQLerror(errorMessage);
        } else {
          const getPrestaRoles = graphqlRoles.data.getPrestaRoles;
          setRoles(getPrestaRoles);
        }
      }
    } catch (err) {
      setQLerror(err);
    }
  };

  const helpInfopersoInfo = () => {
    AlertCustom(t("INFO_PERSO_TITLE"), t("HELP_INFOPERSO_INFO"));
  };

  const helpShareExp = () => {
    AlertCustom(t("SHARE_EXPERIENCE_TITLE"), t("SHARE_EXPERIENCE_HELPER"));
  };

  const mailToClientService = async () => {
    const emailServiceClient = "serviceclient@oiqia.net";
    const { firstName, lastName } = prestaInfo;
    try {
      const suppoted = await Linking.canOpenURL(`mailto:${emailServiceClient}`);
      if (suppoted) {
        await Linking.openURL(
          `mailto:${emailServiceClient}?subject=[OiqiaServices] Retour prestataire ${firstName} ${lastName}`
        );
      }
    } catch (err) {
      AlertCustom(t("SHARE_EXPERIENCE_TITLE"), t("SHARE_EXPERIENCE_FAILED"));
    }
  };

  useEffect(() => {
    setLoading(true);
    getPrestaInfos();
    setLoading(false);
  }, []);

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ImageBackground source={BG_PATH} style={typo.background}>
        <ScrollView>
          {QLerror && QLerror !== "" ? (
            <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
          ) : null}
          <View style={typo.container}>
            <Text style={typo.titleInfo}>Votre Espace Perso</Text>

            <View style={typo.resCard}>
              <View style={typo.underlineCat}>
                <MaterialIcons
                  name="info"
                  size={24}
                  style={{ marginRight: 10 }}
                  color={Colors.oiqia}
                  onPress={() => helpInfopersoInfo()}
                />
                <Text style={typo.category}>{t("INFO_PERSO_TITLE")}</Text>
              </View>
              {!loading && (
                <View>
                  <View>
                    <Text style={typo.h3}>
                      <Feather name="user" size={24} color={Colors.oiqia} />
                      <Text style={[typo.body, styles.userInfoFirstName]}>
                        {" " + prestaInfo.firstName}
                      </Text>
                      <Text style={[typo.body, styles.userInfoLastName]}>
                        {" " + prestaInfo.lastName}
                      </Text>
                    </Text>
                  </View>
                  <View style={styles.userInfoNewLine}>
                    <Text style={typo.h3}>
                      <Feather name="mail" size={24} color={Colors.oiqia} />
                      <Text style={[typo.body, styles.userInfoMail]}>
                        {" " + prestaInfo.email}
                      </Text>
                    </Text>
                  </View>
                  <View style={styles.userInfoNewLine}>
                    <Text style={typo.h3}>
                      <Feather name="phone" size={24} color={Colors.oiqia} />
                      <Text style={[typo.body, styles.userInfoPhone]}>
                        {" " + prestaInfo.phone}
                      </Text>
                    </Text>
                  </View>
                  <View style={styles.userInfoNewLine}>
                    <Text style={typo.h3}>
                      <Feather name="list" size={24} color={Colors.oiqia} />
                      <Text style={[typo.body, styles.userInfoRole]}>
                        {roles.isSubcontractor ? " Prestataire" : ""}
                        {roles.isSubcontractor && roles.isCustomer && " &"}
                        {roles.isCustomer ? " Propriétaire" : ""}
                      </Text>
                    </Text>
                  </View>
                </View>
              )}
            </View>
            {roles.isSubcontractor && (
              <View style={typo.resCard}>
                <View style={typo.underlineCat}>
                  <MaterialIcons
                    name="info"
                    size={24}
                    style={{ marginRight: 10 }}
                    color={Colors.oiqia}
                    onPress={() => helpShareExp()}
                  />
                  <Text style={typo.category}>
                    {t("SHARE_EXPERIENCE_TITLE")}
                  </Text>
                </View>
                <View>
                  <Text style={styles.textMuted}>
                    {t("SHARE_EXPERIENCE_BODY")}
                  </Text>
                  <Button
                    style={{ backgroundColor: Colors.oiqia, marginTop: 10 }}
                    text={t("SHARE_EXPERIENCE_MAIL_BUTTON")}
                    onPress={() => mailToClientService()}
                  />
                </View>
              </View>
            )}
          </View>

          {invoices && invoices.length > 0 && (
            <View style={typo.container}>
              <View style={typo.resCard}>
                <Text style={[typo.category, { marginBottom: 10 }]}>
                  Historique de facturation
                </Text>
                {invoices.map((invoice, index) => (
                  <View key={index} style={styles.invoiceBox}>
                    <View style={styles.underline}>
                      <Text style={typo.h3}>
                        Facture du{" "}
                        {format(new Date(invoice.date), "d MMMM Y", {
                          locale: fr,
                        })}
                      </Text>
                    </View>
                    <View style={styles.column}>
                      <View style={styles.invoiceInfo}>
                        <Text style={typo.h2}>{invoice.total}€</Text>
                        {invoice.paid_date ? (
                          <Text style={[typo.body, { color: "green" }]}>
                            Payée le : {invoice.paid_date}
                          </Text>
                        ) : (
                          <Text style={[typo.body, { color: "red" }]}>
                            Non payée
                          </Text>
                        )}
                      </View>
                      <View style={styles.invoiceInfo}>
                        <Text
                          onPress={() => Linking.openURL(invoice.public_path)}
                          style={{
                            color: Colors.oiqia,
                            textAlign: "right",
                            paddingRight: "10%",
                          }}
                        >
                          <Feather
                            name="eye"
                            size={24}
                            style={{ color: Colors.oiqia }}
                          />
                        </Text>

                        <Text
                          onPress={() => Linking.openURL(invoice.public_path)}
                          style={{ color: Colors.oiqia, textAlign: "right" }}
                        >
                          Voir PDF
                        </Text>
                      </View>
                    </View>
                  </View>
                ))}
              </View>
            </View>
          )}
        </ScrollView>
      </ImageBackground>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  textMuted: {
    fontStyle: "italic",
    color: Colors.grey,
  },
  userInfoNewLine: {
    marginTop: 8,
  },
  userInfoRole: {
    marginTop: 8,
    textTransform: "capitalize",
  },
  userInfoMail: {
    textTransform: "lowercase",
    fontSize: 16,
  },
  userInfoPhone: {
    textTransform: "lowercase",
    fontSize: 16,
  },

  userInfoFirstName: {
    textTransform: "capitalize",
  },

  userInfoLastName: {
    textTransform: "uppercase",
  },

  invoiceBox: {
    marginBottom: 20,
  },

  link: {
    backgroundColor: "#d71d9a",
    color: "white",
    textAlign: "center",
    marginTop: 10,
    borderColor: "#d71d9a",
    borderStyle: "solid",
    borderWidth: 5,
    paddingVertical: 5,
    borderRadius: 20,
  },

  flex: {
    display: "flex",
  },

  imageWrapper: {
    justifyContent: "center",
    alignItems: "center",
  },

  codeWrap: {
    flex: 1,
    alignSelf: "flex-start",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  code: {
    fontSize: 22,
    color: Colors.oiqia,
    borderColor: "#0A0A0AE7",
    borderWidth: 0.5,
    borderRadius: 5,
    letterSpacing: 2,
    padding: 5,
    margin: 10,
    fontFamily: "RobotoBold",
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },

  invoiceInfo: {
    width: "50%",
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
  underlineDot: {
    borderColor: "#0A0A0AE7",
    borderStyle: "dashed",
    borderRadius: 1,
    borderBottomWidth: 1,
    paddingBottom: 10,
    marginBottom: 10,
  },

  wrap10: {
    margin: 15,
  },
  button: {
    borderRadius: 10,
    marginBottom: 10,
    backgroundColor: Colors.oiqia,
  },
  box: {
    marginVertical: 10,
  },
  title: {
    fontSize: 26,
    color: "white",
    textAlign: "center",
    /*     alignItems: "center", */
    /*     justifyContent: "center", */
    marginBottom: 20,
    fontFamily: "OpenSansSemiBold",
  },
  subTitle: {
    fontSize: 15,
    fontWeight: "bold",
    //fontWeight: "700",
    color: "#000030",
    margin: 5,
  },
  subTitleBis: {
    fontSize: 15,
    fontWeight: "bold",
    //fontWeight: "700",
    color: "#808080",
    marginLeft: 5,
    //margin: 5,
  },
  image: {
    height: 150,
    resizeMode: "contain",
  },
  buttonWrapper: {
    width: "90%",
    alignSelf: "center",
    borderRadius: 10,
  },
  tinyLogo: {
    width: 166,
    height: 143,
  },

  imageCard: {
    resizeMode: "contain",
    borderColor: "grey",
    borderWidth: 2,
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
  },

  accesCodeText: {
    textAlign: "center",
    paddingLeft: 0,
  },

  adressCard: {
    padding: 15,
    width: "100%",
    borderColor: "#eae8e1",
    borderWidth: 4,
    borderRadius: 20,
    marginBottom: 30,
  },
  attachmentTitles: {
    left: 5,
    marginBottom: 5,
    fontSize: 17,
    fontWeight: "bold",
  },
  centeredView: {
    flex: 2,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default InfoPerso;
